import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const WelcomeSection = ({ id, titleName }) => {
  const [WelcomeSection, setWelcomeSection] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    try {
      const list = await corefetch(
        `WelcomeSection/GetAboutSectionList?displayesInID=${id}`
      );
      if (list && list.length > 0) {
        setWelcomeSection(list);
      } else {
        setWelcomeSection([]);
      }
    } catch (error) {
      setWelcomeSection([]);
      console.error("Error fetching list:", error);
    }
  };
  if (!WelcomeSection || WelcomeSection.length == 0) {
    return null;
  }

  return (
    <section className="wpo-story-section-s3 section-padding pb-0" id="story">
      <div className="container">
        <div className="wpo-section-title">
          <h2>{titleName} at Meridian</h2>
        </div>
        <div className="wpo-story-wrap">
          {WelcomeSection.map((item) => (
            <div key={item.id} className="wpo-story-item">
              <div
                className="wpo-story-img-wrap wow fadeInLeftSlow"
                data-wow-duration="1700ms"
              >
                <div className="wpo-story-img">
                  <img
                    src={`${ImageURL}${item.imagePath}`}
                    alt={`Section ${item}`}
                    style={{
                      width: "100%", // Ensures the image covers the entire circle
                      height: "100%", // Maintains the aspect ratio
                      objectFit: "cover", // Ensures the image fills the circle without distortion
                    }}
                  />
                </div>
              </div>
              <div
                className="wpo-story-content  wow fadeInRightSlow"
                data-wow-duration="1700ms"
              >
                <div className="wpo-story-content-inner">
                  <h2>{item.title}</h2>
                  <p>{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
